// sagas/nopSaga.js
/* eslint import/prefer-default-export: "off" */
/* eslint no-empty: "off" */
import { put, all } from 'redux-saga/effects';
// import { getFirebase } from 'react-redux-firebase'

export function* nopSaga() {
  // let feedbackStack = []
  // let feedbackUuid = null

  // console.log('getFirebase', getFirebase());
  try {
    yield all([
      // getFirebase().push('/nops', { nice: 'work!' }),
      put({ type: 'NOP_FROM_SAGA' }),
    ]);
  } catch (error) {
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/nopSaga.js